var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shelter-areas-all"},[_c('main-section-shelter-areas-all')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }